import { render, staticRenderFns } from "./ForgotForm.vue?vue&type=template&id=49ab6b5a&scoped=true"
import script from "./ForgotForm.vue?vue&type=script&lang=js"
export * from "./ForgotForm.vue?vue&type=script&lang=js"
import style0 from "./ForgotForm.vue?vue&type=style&index=0&id=49ab6b5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ab6b5a",
  null
  
)

export default component.exports